import React, { useEffect } from 'react'
import  { useSingleMinigrid } from '../../hook';
import { Minigrid } from '../../types/minigridtypes';
import { ResponseAPIWithPagination } from '../../../../common/types/API.types';
import useQuerySelector from '../../../../common/hooks/useQuerySelector';
import minigridAPI from '../../service/minigridAPI';
import MicroModalSelectorSearch from '../../../../common/components/organisme/MicroModalSelectorSearch/MicroModalSelectorSearch';
import { useAuth } from '../../../auth/hooks';


export interface MinigridSelectorPresenterProps {
    isError?: boolean ;
    onChange : (minigrid: Minigrid) => void;
    value : Minigrid | null | undefined;
    variant?: "dark" | "light";
    initMinigridId?: string | null;
    label?: string;
    excludeMinigridIds?: string[];
}

export default function MinigridSelector({
    onChange, isError, value, variant = "light", initMinigridId, label= "Minigrid", excludeMinigridIds
}: MinigridSelectorPresenterProps) {
 

    const {singleMinigridQuery } = useSingleMinigrid(initMinigridId || undefined);
    const {getAccountIdUser} = useAuth();
    useEffect(() => {
        if(singleMinigridQuery.data && initMinigridId  && !value ){
            onChange(singleMinigridQuery.data);
        }
    },[singleMinigridQuery.data]) // eslint-disable-line
   


  const {resultFound, isLoading,  setValueQuery, valueQuery } = useQuerySelector<ResponseAPIWithPagination<Minigrid>>(
    {
      getSearch : (query: string) => {
       
            return  minigridAPI.getAllMinigrids(0,0, {querySearch: query, accountId: getAccountIdUser()});
    }}
  );


  



    const onClickItem = (item: any) => {
        onChange(item.item);
    }

    const convertToResultItem = (minigrid: Minigrid[]) => {
        const excluded = new Set(excludeMinigridIds ?? []);
        return minigrid
            .filter((m) => !excluded.has(m.minigrid_id))
            .map((minigrid) => {
                return {
                    id: minigrid.minigrid_id,
                    name: minigrid.minigrid_name,
                    item: minigrid
                }
            })
    }


    return <MicroModalSelectorSearch
        valueSelectedName={value?.minigrid_name}
        placeholder="Sélectionner un minigrid"
        result={  resultFound ? convertToResultItem(resultFound?.data || []) : []}
        setQuery={setValueQuery}
        onClickItem={onClickItem}
        isLoading={isLoading}
        valueQuery={valueQuery}
        isError={isError}
        emptyMessage="Aucun minigird trouvé"
        variant={variant}
        label={label}
    />
};

